const $page = document.querySelector('.page');
const $searchBar = document.querySelector('.menu-search__input');
const $serchPopup = document.querySelector('.search-popup');
